(() => {
  document.addEventListener('click', (event) => {
    const reviewButton = event.target.closest('.tt-write-reviews');
    const context = window.luscentraReviewContext;
    if (!reviewButton || !context || context.customerLoggedIn) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const separator = context.productPath.includes('?') ? '&' : '?';
    const returnUrl = `${context.productPath}${separator}req=review`;
    window.location.assign(`/account/login?return_url=${encodeURIComponent(returnUrl)}`);
  }, true);

  const enforcePagination = () => {
    if (!window.vstar_review_settings) return false;
    window.vstar_review_settings.reviews_per_page_number = 5;
    window.vstar_review_settings.review_pagination_type = 1;
    return true;
  };
  if (!enforcePagination()) {
    let attempts = 0;
    const paginationTimer = window.setInterval(() => {
      attempts += 1;
      if (enforcePagination() || attempts >= 100) window.clearInterval(paginationTimer);
    }, 50);
  }
  const destination = document.querySelector('[data-lus-full-reviews]');
  const slot = destination?.querySelector('[data-lus-full-reviews-slot]');
  const summary = document.querySelector('[data-lus-review-summary]');
  if (!destination || !slot || !summary) return;

  const paginateReviews = (widget) => {
    const list = widget.querySelector('.tt-review-list');
    if (!list || widget.dataset.lusPaginationReady === 'true') return;
    widget.dataset.lusPaginationReady = 'true';

    let activePage = 0;
    let lastCount = -1;
    let pagination;

    const render = () => {
      const reviews = [...list.querySelectorAll('.list-review')];
      if (!reviews.length) return;

      const pageCount = Math.ceil(reviews.length / 5);
      activePage = Math.min(activePage, pageCount - 1);
      reviews.forEach((review, index) => {
        review.style.display = Math.floor(index / 5) === activePage ? '' : 'none';
      });

      widget.querySelectorAll('.page-control').forEach((control) => {
        control.style.setProperty('display', 'none', 'important');
      });

      if (reviews.length === lastCount) {
        pagination?.querySelectorAll('[data-lus-review-page]').forEach((button) => {
          const isCurrent = Number(button.dataset.lusReviewPage) === activePage;
          button.classList.toggle('is-active', isCurrent);
          if (isCurrent) button.setAttribute('aria-current', 'page');
          else button.removeAttribute('aria-current');
        });
        const previous = pagination?.querySelector('[data-lus-review-previous]');
        const next = pagination?.querySelector('[data-lus-review-next]');
        if (previous) previous.disabled = activePage === 0;
        if (next) next.disabled = activePage === pageCount - 1;
        return;
      }

      lastCount = reviews.length;
      pagination?.remove();
      if (pageCount < 2) return;

      pagination = document.createElement('nav');
      pagination.className = 'lus-review-pagination';
      pagination.setAttribute('aria-label', 'Review pages');
      pagination.innerHTML = `
        <button type="button" data-lus-review-previous aria-label="Previous review page">&#8592;</button>
        <span class="lus-review-pagination__pages"></span>
        <button type="button" data-lus-review-next aria-label="Next review page">&#8594;</button>
      `;
      const pages = pagination.querySelector('.lus-review-pagination__pages');
      for (let page = 0; page < pageCount; page += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(page + 1);
        button.dataset.lusReviewPage = String(page);
        button.setAttribute('aria-label', `Review page ${page + 1}`);
        pages.appendChild(button);
      }
      list.insertAdjacentElement('afterend', pagination);

      const changePage = (page) => {
        activePage = Math.max(0, Math.min(page, pageCount - 1));
        render();
        list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      pagination.addEventListener('click', (event) => {
        const pageButton = event.target.closest('[data-lus-review-page]');
        if (pageButton) changePage(Number(pageButton.dataset.lusReviewPage));
        if (event.target.closest('[data-lus-review-previous]')) changePage(activePage - 1);
        if (event.target.closest('[data-lus-review-next]')) changePage(activePage + 1);
      });
      render();
    };

    render();
    let renderTimer;
    const listObserver = new MutationObserver(() => {
      window.clearTimeout(renderTimer);
      renderTimer = window.setTimeout(() => {
        activePage = 0;
        lastCount = -1;
        render();
      }, 50);
    });
    listObserver.observe(list, { childList: true });
  };

  const readData = (widget) => {
    const text = widget.textContent.replace(/\s+/g, ' ').trim();
    const count = text.match(/([\d,]+)\s+reviews?/i);
    const rating = text.match(/(?:^|\s)([0-5](?:\.\d)?)\s+(?=[\d,]+\s+reviews?)/i)
      || text.match(/(?:^|\s)([0-5](?:\.\d)?)(?:\s|$)/);
    return {
      rating: summary.dataset.fallbackRating || rating?.[1] || '',
      count: summary.dataset.fallbackCount || count?.[1] || ''
    };
  };

  const relocate = () => {
    const widget = [...document.querySelectorAll('.trustoo-reviews-wrapper, #vstar-reviews, .vstar-reviews, vstar-reviews')]
      .find((item) => !item.closest('[data-lus-full-reviews-slot]'));
    if (!widget) return false;

    const data = readData(widget);
    const score = summary.querySelector('[data-lus-review-score]');
    const count = summary.querySelector('[data-lus-review-count]');
    if (score && data.rating) score.textContent = data.rating;
    if (count && data.count) {
      const singular = Number(String(data.count).replace(/,/g, '')) === 1;
      count.textContent = `${data.count} ${singular ? 'review' : 'reviews'}`;
    }

    widget.setAttribute('data-lus-reviews-relocated', 'true');
    slot.appendChild(widget);
    destination.hidden = false;
    summary.hidden = false;
    return true;
  };

  if (relocate()) return;
  const observer = new MutationObserver(() => {
    if (relocate()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
})();
